import api from "../../../../api";
import urls from "../../../../urls";

export async function deactivate2FaMethod(code: string) {
  await api.post<void>(urls.auth.deactivate2FaMethod(), { code });
}
